import { createUseStyles } from 'react-jss';
import { getBorderRadius } from './Skeleton.helpers';
import { SkeletonThemeProps, SkeletonThemeRuleNames } from './Skeleton.types';

export const useStyles = createUseStyles<SkeletonThemeRuleNames, SkeletonThemeProps>({
  root: (props) => ({
    ...props?.style,
    height: typeof props?.height === 'number' ? `${props?.height}px` : '100%',
    width: typeof props?.width === 'number' ? `${props?.width}px` : '100%',
    ...props?.style.root,
  }),
  skeleton: (props) => ({
    background: '#EFEDED',
    animation: '$pulsate 1.5s ease-in-out 0.5s infinite',
    height: '100%',
    width: '100%',
    borderRadius: getBorderRadius(props?.variant),
    ...props?.style.skeleton,
  }),
  '@keyframes pulsate': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.4,
    },
    '100%': {
      opacity: 1,
    },
  },
});
